import WyjazdyNadchodzace from "./WyjazdyNadchodzace"

export default WyjazdyNadchodzace
